import { useState } from "react";

import { sanitizeCurrencyInput } from "../../lib/utils";
import { brl, cmvDe, lerNumero, markupDe, precoPorMarkup, textoPct } from "./lib/precos";

const corCmv = (pct) => (pct <= 30 ? "text-emerald-600 dark:text-emerald-400" : pct <= 50 ? "text-amber-600 dark:text-amber-400" : "text-red-600 dark:text-red-400");

/** Preço do produto editável aqui mesmo, junto com o markup: digita o preço e o
 *  markup sai; digita o markup e o preço sai (preço = custo × markup). É o MESMO
 *  campo de preço da aba Produto — grava no Salvar. */
export default function SeuPreco({ custo, preco, setPreco, rotulo, sufixo }) {
  const [markupTxt, setMarkupTxt] = useState(null); // texto enquanto digita no markup
  const precoNum = parseFloat(preco) || 0;
  const k = markupDe(precoNum, custo);
  const cmv = cmvDe(precoNum, custo);
  const semCusto = !(custo > 0);
  const markupMostrado = markupTxt ?? (k > 0 ? k.toFixed(2).replace(".", ",") : "");

  const digitarMarkup = (bruto) => {
    const v = bruto.replace(/[^\d.,]/g, "");
    setMarkupTxt(v);
    const n = lerNumero(v);
    if (n > 0 && custo > 0) setPreco(precoPorMarkup(custo, n).toFixed(2));
  };

  return (
    <div className="rounded-xl border border-emerald-200/60 dark:border-emerald-900/50 bg-gradient-to-br from-emerald-50 to-teal-50/40 dark:from-emerald-950/20 dark:to-teal-950/10 p-3 flex flex-col gap-2.5">
      <span className="text-[10px] uppercase tracking-wider font-bold text-muted-foreground">{rotulo}</span>
      <div className="grid grid-cols-[1fr_auto] gap-2">
        <div className="relative">
          <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-sm text-muted-foreground font-bold">R$</span>
          <input
            data-e2e="precificacao-preco"
            type="text"
            inputMode="decimal"
            // Mostra com vírgula (R$ 13,90); o estado continua com ponto (sanitize troca)
            value={String(preco ?? "").replace(".", ",")}
            onChange={(e) => setPreco(sanitizeCurrencyInput(e.target.value))}
            placeholder="0,00"
            aria-label={rotulo}
            className="w-full h-10 rounded-lg border bg-background pl-9 pr-2 text-lg font-black tabular-nums focus:outline-none focus:ring-2 focus:ring-emerald-500"
          />
        </div>
        <div className="relative w-[92px]">
          <input
            data-e2e="precificacao-markup"
            type="text"
            inputMode="decimal"
            value={markupMostrado}
            disabled={semCusto}
            onChange={(e) => digitarMarkup(e.target.value)}
            onBlur={() => setMarkupTxt(null)}
            placeholder="—"
            aria-label="Markup"
            className="w-full h-10 rounded-lg border bg-background pl-2 pr-6 text-lg font-black tabular-nums text-right focus:outline-none focus:ring-2 focus:ring-emerald-500 disabled:opacity-50"
          />
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-muted-foreground font-bold">x</span>
        </div>
      </div>
      <div className="grid grid-cols-[1fr_92px] gap-2 -mt-1.5 text-[10px] text-muted-foreground">
        <span>Preço de venda{sufixo ? ` (${sufixo.slice(1)})` : ""}</span>
        <span className="text-right">Markup</span>
      </div>

      {semCusto ? (
        <p className="text-[11px] text-muted-foreground">Adicione itens na ficha para calcular markup e CMV.</p>
      ) : precoNum > 0 ? (
        <p className="text-[11px] text-muted-foreground leading-tight">
          CMV <strong className={corCmv(cmv)}>{textoPct(cmv)}</strong>
          {" · "}Lucro <strong className={precoNum - custo >= 0 ? "text-foreground" : "text-red-600 dark:text-red-400"}>{brl(precoNum - custo)}</strong>
        </p>
      ) : (
        <p className="text-[11px] text-muted-foreground">Digite o preço ou o markup.</p>
      )}
      <p className="text-[10px] text-muted-foreground/80 mt-auto">Grava quando você clicar em Salvar o produto.</p>
    </div>
  );
}
